(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('summary.menu-drawer__menu-item, summary.menu-drawer__child-menu-item')
      .forEach((summary) => {
        summary.addEventListener('click', function (e) {
          // 点击箭头不跳转
          if (e.target.closest('.icon-caret')) return;

          // 点击其他区域跳转
          const link = summary.dataset.href;
          if (link) window.location.href = link;
        });
      });
  });
  } catch(e) { console.error(e); }
})();

})();
